import * as React from "react"
import { Flex, ResponsiveValue } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"
import * as CSS from "csstype"

interface LanguageButtonProps {
  toggleModal: () => void
  isMobile?: boolean
  right?: ResponsiveValue<
    number | `${number}px` | `${number}rem` | `${number}em`
  >
  top?: ResponsiveValue<number | `${number}px` | `${number}rem` | `${number}em`>
  zIndex?: number
}

const _LanguageButton: React.FC<LanguageButtonProps> = ({
  toggleModal,
  isMobile,
  right,
  top,
  zIndex,
}) => {
  const { i18n } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="2rem"
      height="2rem"
      pos={isMobile ? "relative" : "absolute"}
      marginLeft={isMobile && "auto"}
      top={top ?? "0px"}
      right={right ?? "0px"}
      zIndex={zIndex}
      bg={roomStyles?.joinButtonBackgroundColor ?? "#1AC541"}
      textColor={roomStyles?.joinPageButtonTextColor ?? "#FFFFFF"}
      _hover={{
        backgroundColor:
          roomStyles?.joinButtonMouseoverBackgroundColor ?? "#24A840",
        textColor: roomStyles?.joinPageButtonMouseoverTextColor ?? "#FFFFFF"
      }}
      borderRadius="50%"
      onClick={toggleModal}
      cursor="pointer"
    >
      {i18n.language}
    </Flex>
  )
}

export const LanguageButton = React.memo(_LanguageButton)
